import FilterControls from "./FilterControls";
import SortControls from "./SortControls";

export default {
  FilterControls,
  SortControls,
};
